import React, { useEffect, useState } from "react";
import "./style.scss";
import { useCurrentUser } from "../../layouts/UserContext";
import {
  GameCoins,
  GameGuide,
  GameItem,
  GameResult,
  GameStartCountdown,
  GameTimer,
} from "./components";
import { CommonUtil } from "../../utils/CommonUtil";
import { APP_GAME_KWAMI } from "../../constants/kwami";
import { APP_ROUTES } from "../../constants";
import { useNavigate } from "react-router";
import { telegramMock } from "telegram.consts";
import axios from "axios";

const webApp = window.Telegram.WebApp;

const LOCAL_GAME_KWAMI = []
  .concat(Array(16).fill(APP_GAME_KWAMI.tikki))
  .concat(Array(24).fill(APP_GAME_KWAMI.plag))
  .concat(Array(32).fill(APP_GAME_KWAMI.banix))
  .concat(Array(8).fill(APP_GAME_KWAMI.pollen))
  .concat(Array(8).fill(APP_GAME_KWAMI.xuppu))
  .sort(() => Math.random() - 0.5);

const LOCAL_GAME_STATE = {
  GUIDE: "guide",
  COUNTDOWN: "countdown",
  PLAYING: "playing",
  RESULT: "result",
};

const LOCAL_GAME_RESPAWN_SPEED = [
  700, // 60s
  650, // 50s
  600, // 40s
  550, // 30s
  500, // 20s
  450, // 10s
];

const LOCAL_GAME_COUNTDOWN_SECONDS = 3;
const LOCAL_GAME_SECONDS = 60;
const LOCAL_GAME_FREEZE_SECONDS = 5;

export const GamePage = () => {
  const { user, setUser } = useCurrentUser();
  const [gameUuid, setGameUuid] = useState(null);
  const [gameState, setGameState] = useState(
    user.guideCompleted ? LOCAL_GAME_STATE.COUNTDOWN : LOCAL_GAME_STATE.GUIDE
  );
  const [gameSpeed, setGameSpeed] = useState(1);
  const [gameRespawn, setGameRespawn] = useState(LOCAL_GAME_RESPAWN_SPEED[0]);
  const [gameFreeze, setGameFreeze] = useState(false);
  const [gameCoins, setGameCoins] = useState(0);
  const [gameBonus, setGameBonus] = useState(0);
  const [gameItems, setGameItems] = useState([]);

  useEffect(() => {
    console.log("gameState", gameState);
  }, [gameState]);

  useEffect(() => {
    console.log("game user", user);
  }, [user]);

  const navigate = useNavigate();

  const start = () => {
    console.log("call start");
    axios
      .post("https://lovi-kwami.tv3.ru/api/ladybug-game/start-game", {
        hash: user.authToken,
      })
      .then((response) => {
        console.log("[Ladybug.Game] > start > hash: ", response);
        setGameUuid(response.data.uuid);
      });
  };

  const stop = (uuid, score) => {
    axios
      .post("https://lovi-kwami.tv3.ru/api/ladybug-game/stop-game", {
        uuid,
        score,
      })
      .then((response) => {
          const currentTime = new Date();
          const cutoffTime = new Date("2024-12-21T19:00:00Z");
          const isCompetitionFinished = currentTime >= cutoffTime;

        console.log("[Ladybug.Game] > stop > hash: ", response);
        console.log(
          "[Ladybug.Game] > stop > coins: " +
            response.data.game.score +
            " bonus: " +
            response.data.game.bonus
        );
        setGameUuid(null);
        setGameCoins(response.data.game.score);
        //    setGameBonus(response.data.game.bonus);
        console.log("updated user", {
          ...user,
          coins: user.coins + response.data.game.score,
        });
        setUser({ ...user, coins: user.coins + (isCompetitionFinished ? 0 : response.data.game.score)});
        // TO DO Поменять когда начнется новый конкурс
      })
      .catch(() => {
        console.log("[Ladybug.Game] > stop failed");
      });
  };

  const restart = () => {
    console.log("[Ladybug.Game] > restart");
    axios
      .post("https://lovi-kwami.tv3.ru/api/ladybug-game/start-game", {
        hash: user.authToken,
      })
      .then((response) => {
        setGameUuid(response.data.uuid);
        setGameSpeed(1);
        setGameRespawn(LOCAL_GAME_RESPAWN_SPEED[0]);
        setGameFreeze(false);
        setGameCoins(0);
        setGameBonus(0);
        setGameItems([]);
        setGameState(LOCAL_GAME_STATE.COUNTDOWN);
      });
    CommonUtil().ymReachGoal("ladybug_game_click_restart");
  };

  const addRandomGameItem = () => {
    const items = LOCAL_GAME_KWAMI.sort(() => Math.random() - 0.5);
    const randomInt = CommonUtil().randomInteger(0, items.length - 1);
    const randomGameItem = items[randomInt];
    console.log("randomGameItem", randomGameItem);
    setGameItems((prev) => [
      ...prev,
      <GameItem
        key={"game_item_" + prev.length}
        speed={gameSpeed}
        left={CommonUtil().randomInteger(2, 78)}
        image={randomGameItem.image}
        coins={randomGameItem.coins}
        reset={randomGameItem.reset}
        onClick={() => {
          if (randomGameItem.reset) {
            setGameCoins(0);
          } else if (randomGameItem.freeze) {
            if (false === gameFreeze) {
              setGameFreeze(true);
              console.log("[Ladybug.Game] > freeze");
            }
          } else {
            setGameCoins((prev) => prev + randomGameItem.coins);
          }
          if ("tikki" === randomGameItem.code) {
            CommonUtil().ymReachGoal("ladybug_game_click_kwami_tikki");
          } else if ("plag" === randomGameItem.code) {
            CommonUtil().ymReachGoal("ladybug_game_click_kwami_plagg");
          } else if ("trix" === randomGameItem.code) {
            CommonUtil().ymReachGoal("ladybug_game_click_kwami_trikks");
          } else if ("pollen" === randomGameItem.code) {
            CommonUtil().ymReachGoal("ladybug_game_click_kwami_pollen");
          } else if ("xuppu" === randomGameItem.code) {
            CommonUtil().ymReachGoal("ladybug_game_click_kwami_shupp");
          }
        }}
      />,
    ]);
  };

  // *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** //
  useEffect(() => {
    if (gameUuid) {
      return;
    }
    console.log("[Ladybug.Game] > start");
    start();
    webApp.onEvent("viewportChanged", (isStateStable) => {
      if (isStateStable && !webApp.isExpanded) {
        navigate(APP_ROUTES.HOME);
      }
    });
  }, [gameUuid]);

  useEffect(() => {
    if (gameState === LOCAL_GAME_STATE.PLAYING && !gameFreeze) {
      const timer = setTimeout(() => addRandomGameItem(), gameRespawn);
      return () => clearTimeout(timer);
    }
  }, [gameState, gameFreeze, gameItems]);

  useEffect(() => {
    if (true === gameFreeze) {
      window.setTimeout(() => {
        setGameFreeze(false);
        console.log("[Ladybug.Game] > unfreeze");
      }, LOCAL_GAME_FREEZE_SECONDS * 1000);
    }
  }, [gameFreeze]);

  useEffect(() => console.log("[Ladybug.Game] > " + gameState), [gameState]);

  // *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** //

  return (
    <div
      className={
        "app-game app-game_london app-game_speed_" +
        gameSpeed +
        (gameFreeze ? " app-game_freeze" : "")
      }
    >
      {/* Overlay */}
      <div className="app-game--overlay-top"></div>

      {/* Guide */}
      {LOCAL_GAME_STATE.GUIDE === gameState && (
        <GameGuide
          onCompleted={() => setGameState(LOCAL_GAME_STATE.COUNTDOWN)}
        />
      )}

      {/* Countdown */}
      {LOCAL_GAME_STATE.COUNTDOWN === gameState && (
        <GameStartCountdown
          seconds={LOCAL_GAME_COUNTDOWN_SECONDS}
          onStop={() => setGameState(LOCAL_GAME_STATE.PLAYING)}
        />
      )}

      {/* Header */}
      {[LOCAL_GAME_STATE.COUNTDOWN, LOCAL_GAME_STATE.PLAYING].includes(
        gameState
      ) && (
        <header className="app-game--header">
          {LOCAL_GAME_STATE.COUNTDOWN === gameState && (
            <div className="app-game-timer">01:00</div>
          )}
          {LOCAL_GAME_STATE.COUNTDOWN !== gameState && (
            <GameTimer
              seconds={LOCAL_GAME_SECONDS}
              freeze={gameFreeze}
              onEdge={(edge) => {
                if (edge === 50) {
                  setGameSpeed(1);
                  setGameRespawn(LOCAL_GAME_RESPAWN_SPEED[1]);
                  console.log("[Ladybug.Game] > edge ", {
                    time: edge,
                    speed: 1.5,
                    respawn: LOCAL_GAME_RESPAWN_SPEED[1],
                  });
                } else if (edge === 40) {
                  setGameSpeed(2);
                  setGameRespawn(LOCAL_GAME_RESPAWN_SPEED[2]);
                  console.log("[Ladybug.Game] > edge ", {
                    time: edge,
                    speed: 1.5,
                    respawn: LOCAL_GAME_RESPAWN_SPEED[2],
                  });
                } else if (edge === 30) {
                  setGameSpeed(3);
                  setGameRespawn(LOCAL_GAME_RESPAWN_SPEED[3]);
                  console.log("[Ladybug.Game] > edge ", {
                    time: edge,
                    speed: 2.5,
                    respawn: LOCAL_GAME_RESPAWN_SPEED[3],
                  });
                } else if (edge === 20) {
                  setGameSpeed(4);
                  setGameRespawn(LOCAL_GAME_RESPAWN_SPEED[4]);
                  console.log("[Ladybug.Game] > edge ", {
                    time: edge,
                    speed: 3,
                    respawn: LOCAL_GAME_RESPAWN_SPEED[4],
                  });
                } else if (edge === 10) {
                  setGameSpeed(5);
                  setGameRespawn(LOCAL_GAME_RESPAWN_SPEED[5]);
                  console.log("[Ladybug.Game] > edge ", {
                    time: edge,
                    speed: 4,
                    respawn: LOCAL_GAME_RESPAWN_SPEED[5],
                  });
                }
              }}
              onStop={() => {
                stop(gameUuid, gameCoins);
                setGameState(LOCAL_GAME_STATE.RESULT);
                setGameSpeed(0);
              }}
            />
          )}
          <GameCoins coins={gameCoins} />
        </header>
      )}

      {/* Playing */}
      {LOCAL_GAME_STATE.PLAYING === gameState && (
        <div className="app-game--items">
          {gameItems.map((gameItem) => gameItem)}
        </div>
      )}

      {/* Result */}
      {LOCAL_GAME_STATE.RESULT === gameState && (
        <GameResult
          coins={gameCoins}
          bonus={gameBonus}
          onRestart={() => restart()}
        />
      )}
    </div>
  );
};
